import {create} from 'zustand';

type VelaChatDraftStore = {
  draft: string | null;
  setDraft: (draft: string) => void;
  clearDraft: () => void;
};

export const useVelaChatDraftStore = create<VelaChatDraftStore>(set => ({
  draft: null,
  setDraft: draft => set({draft}),
  clearDraft: () => set({draft: null}),
}));
